module.exports = __webpack_public_path__ + "static/media/certificatesMobile.b0e5d9d5.png";